module.exports = {"431103001":"梅湾街道","431103002":"菱角山街道","431103003":"肖家园街道","431103004":"杨家桥街道","431103005":"梧桐街道","431103006":"凤凰街道","431103007":"珊瑚街道","431103008":"曲河街道","431103009":"岚角山街道","431103101":"花桥街镇","431103102":"普利桥镇","431103103":"牛角坝镇","431103104":"高溪市镇","431103105":"黄阳司镇","431103106":"上岭桥镇","431103108":"伊塘镇","431103110":"蔡市镇","431103201":"杨村甸乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431103.json
// module id = 1904
// module chunks = 0